import { useCallback } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

const ParticlesBackground = () => {
  const init = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  return (
    <Particles
      id="tspartickles"
      init={init}
      options={{
        fullScreen: { enable: true, zIndex: -1 },
        background: { color: "#161513" }, // tumma tausta
        particles: {
          number: { value: 30, density: { enable: true, area: 900 } },
          color: { value: ["#00ccff", "#c800ff", "#5a71ff"] }, // värit
          shape: { type: "circle" }, // vain ympyröitä
          size: { value: { min: 1, max: 8 } }, // kuplien koko
          opacity: {
            value: 0.6,
            random: true,
            animation: { enable: true, speed: 1, minimumValue: 0.2 },
          },
          move: {
            enable: true,
            speed: 1,
            direction: "none",
            outModes: { default: "out" },
          },
          links: { enable: true }, // verkko?
        },
        interactivity: {
          events: {
            onHover: { enable: true, mode: "repulse" }, // reagoi hiireen
          },
          modes: {
            repulse: { distance: 60, duration: 0.4 },
          },
        },
        detectRetina: true,
      }}
    />
  );
};

export default ParticlesBackground;
